import { Button, Flex, Result, Typography } from "antd";

import s from "./ComingSoon.module.css";
import { ComingSoonProps } from "./types";

const { Text } = Typography;

export const ComingSoon = ({
  title,
  subTitle,
  actionLabel,
  onAction,
}: ComingSoonProps) => (
  <Flex align="center" justify="center" className={s.root} vertical>
    <Result
      status="info"
      title={title}
      subTitle={<Text className={s.subtitle}>{subTitle}</Text>}
    />
    {actionLabel && onAction && (
      <Button
        type="primary"
        size="large"
        onClick={onAction}
        className={s.action}
      >
        {actionLabel}
      </Button>
    )}
  </Flex>
);
